function key(node, index) {
  const a = node.attrs || {};
  if (node.tag === "title") return "title";
  if (node.tag === "meta") {
    return `meta:${a.name || a.property || a.httpEquiv || a.charset}`;
  }
  if (node.tag === "link") {
    return `link:${a.rel}:${a.rel === "canonical" ? "" : a.hrefLang || a.href}`;
  }
  if (node.tag === "script" && a.type === "application/ld+json") {
    try {
      const data = JSON.parse(node.text);
      return `schema:${data["@type"] || index}`;
    } catch { /* Keep independent scripts. */ }
  }
  return `${node.tag}:${a.id || index}`;
}
export function resolveMetadata(entries) {
  const nodes = new Map();
  [...entries].sort((a, b) => a.priority - b.priority || a.order - b.order)
    .forEach((entry) => {
      entry.nodes.forEach((node, index) =>
        nodes.set(key(node, `${entry.order}:${index}`), node)
      );
    });
  const setMeta = (name, content) => {
    if (content) {
      nodes.set(`meta:${name}`, {
        tag: "meta",
        attrs: {
          [name.startsWith("og:") ? "property" : "name"]: name,
          content,
        },
      });
    }
  };
  const title = nodes.get("title")?.text;
  const description = nodes.get("meta:description")?.attrs.content;
  ["title", "og:title", "twitter:title", "DC.title"].forEach((name) =>
    setMeta(name, title)
  );
  ["og:description", "twitter:description"].forEach((name) =>
    setMeta(name, description)
  );
  const canonicalNode = nodes.get("link:canonical:");
  const base = entries.find((entry) => entry.priority === 0)?.nodes.find(
    (node) => node.tag === "link" && node.attrs?.rel === "canonical",
  )?.attrs.href;
  if (base && canonicalNode) {
    try {
      const url = new URL(canonicalNode.attrs.href, base);
      canonicalNode.attrs = {
        ...canonicalNode.attrs,
        href: new URL(url.pathname, base).href,
      };
    } catch {
      canonicalNode.attrs = { ...canonicalNode.attrs, href: base };
    }
  }
  const canonical = canonicalNode?.attrs.href;
  setMeta("twitter:image", nodes.get("meta:og:image")?.attrs.content);
  ["og:url", "twitter:url"].forEach((name) => setMeta(name, canonical));
  setMeta("googlebot", nodes.get("meta:robots")?.attrs.content);
  return [...nodes.values()];
}
